module.exports = __webpack_public_path__ + "img/KSC08814.7940b9b0.jpg";